import { LabelRegular, YStack } from 'smoothie';

import { LegalLink } from '../common/LegalLink';
import { FootnoteTitle, type FootnoteTitleProps } from './FootnoteTitle';
import {
    INVESTMENT_MANAGEMENT_AGREEMENT_LABEL,
    INVESTMENT_MANAGEMENT_AGREEMENT_URL,
} from './legal';

export const InvestmentManagementAgreementDisclosure = ({
    color = '$gray900',
    titleColor,
    superscript,
}: {
    color?: string;
    titleColor?: string;
    superscript?: FootnoteTitleProps['superscript'];
}) => {
    return (
        <YStack>
            <FootnoteTitle
                title="Investment Management"
                superscript={superscript}
                color={titleColor}
            />
            <LabelRegular color={color}>
                See the{' '}
                <LegalLink
                    href={INVESTMENT_MANAGEMENT_AGREEMENT_URL}
                    color={color}
                >
                    {INVESTMENT_MANAGEMENT_AGREEMENT_LABEL}
                </LegalLink>{' '}
                for more details.
            </LabelRegular>
        </YStack>
    );
};
